export const decToHex = (value: number, scaleBy = 1): string => {
  const hex = Math.round(value * scaleBy).toString(16);

  return hex.length === 1 ? `0${hex}` : hex;
};
